module.exports = __webpack_public_path__ + "static/media/capri-6.27dc3658.jpg";